export default "__VITE_ASSET__SCJKxkMl__"